import { create } from 'zustand';

interface DiagnosticLog {
  id: string;
  timestamp: string;
  step: string;
  data?: any;
}

interface DiagnosticState {
  logs: DiagnosticLog[];
  lastError: { code: string; message: string } | null;
  redirectStatus: 'IDLE' | 'START' | 'OK' | 'NULL' | 'ERROR' | 'TIMEOUT';
  googleButtonClicks: number;
  addLog: (step: string, data?: any) => void;
  setLastError: (code: string, message: string) => void;
  setRedirectStatus: (status: DiagnosticState['redirectStatus']) => void;
  incrementGoogleClicks: () => void;
  clearLogs: () => void;
  loadFromSession: () => void;
}

const STORAGE_KEY = 'verbo_diagnostic_logs';

export const useDiagnosticStore = create<DiagnosticState>((set, get) => ({
  logs: [],
  lastError: null,
  redirectStatus: 'IDLE',
  googleButtonClicks: 0,
  addLog: (step, data) => {
    console.log(`[Diagnostic] ${step}`, data || '');
    const newLog = { 
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toLocaleTimeString(), 
      step, 
      data 
    };
    set((state) => {
      const updatedLogs = [...state.logs, newLog].slice(-50);
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updatedLogs));
      } catch (e) {}
      return { logs: updatedLogs };
    });
  },
  setLastError: (code, message) => set({ lastError: { code, message } }),
  setRedirectStatus: (status) => set({ redirectStatus: status }),
  incrementGoogleClicks: () => set((state) => ({ googleButtonClicks: state.googleButtonClicks + 1 })),
  clearLogs: () => {
    sessionStorage.removeItem(STORAGE_KEY);
    set({ logs: [], lastError: null, redirectStatus: 'IDLE', googleButtonClicks: 0 });
  },
  loadFromSession: () => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          set({ logs: parsed });
        }
      }
    } catch (e) {}
  }
}));
